import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

import deFile_uploads from './locales/de/file_uploads.json'
import dePdf from './locales/de/pdf.json'
import enFile_uploads from './locales/en-gb/file_uploads.json'
import enPdf from './locales/en-gb/pdf.json'
import frFile_uploads from './locales/fr/file_uploads.json'
import frPdf from './locales/fr/pdf.json'
import itFile_uploads from './locales/it/file_uploads.json'
import itPdf from './locales/it/pdf.json'
import nlFile_uploads from './locales/nl/file_uploads.json'
import nlPdf from './locales/nl/pdf.json'
import plFile_uploads from './locales/pl/file_uploads.json'
import plPdf from './locales/pl/pdf.json'
import ruFile_uploads from './locales/ru/file_uploads.json'
import ruPdf from './locales/ru/pdf.json'
import trFile_uploads from './locales/tr/file_uploads.json'
import trPdf from './locales/tr/pdf.json'

const resources = {
  en: {
    file_uploads: enFile_uploads,
    pdf: enPdf,
  },
  de: {
    file_uploads: deFile_uploads,
    pdf: dePdf,
  },
  fr: {
    file_uploads: frFile_uploads,
    pdf: frPdf,
  },
  it: {
    file_uploads: itFile_uploads,
    pdf: itPdf,
  },
  nl: {
    file_uploads: plFile_uploads,
    pdf: plPdf,
  },
  pl: {
    file_uploads: nlFile_uploads,
    pdf: nlPdf,
  },
  ru: {
    file_uploads: ruFile_uploads,
    pdf: ruPdf,
  },
  tr: {
    file_uploads: trFile_uploads,
    pdf: trPdf,
  },
}

// It throws whatever is done as an inline check. Some black magic seems to be around here.
// lng: i18n !== undefined && i18n?.language ? i18n.language : 'de', isn't working. No Idea why.
let lang = 'de'
try {
  lang = i18n.language ? i18n.language : 'de'
} catch (x) {
  // I don't care about the error
}


i18next.use(initReactI18next).init({
  resources,
  lng: lang,
  defaultNS: 'file_uploads',
  nsSeparator: ':',
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
})

export default i18next
